export default "__VITE_ASSET__D$Doeiv___"